import { createSlice } from '@reduxjs/toolkit';
import { amendOrderThunk } from './AmendmentActions';

export interface IAmendmentData {
  loading: boolean;
}

const initialState: IAmendmentData = {
  loading: false,
};

const amendmentSlice = createSlice({
  name: 'Amendment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(amendOrderThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(amendOrderThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(amendOrderThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

// export const {} = amendmentSlice.actions;
export default amendmentSlice.reducer;
